import React, { Suspense } from "react";
import { Route, Switch } from "react-router";
import Header from "./components/Header";
import Subnav from "./components/Subnav";
import { HashRouter } from "react-router-dom";
import "toastr/build/toastr.min.css";
import "react-confirm-alert/src/react-confirm-alert.css";
import "./base.css";
import Auth from "./components/Auth";
import Loading from "./components/Loading";
import GetPermissions from "./components/GetPermissions";
const Add = React.lazy(() => import("./components/Add"));
const Acronym = React.lazy(() => import("./components/Acronym"));
const HelpOld = React.lazy(() => import("./components/HelpOld"));
const Help = React.lazy(() => import("./components/Help"));
const Home = React.lazy(() => import("./components/Home"));
const Upload = React.lazy(() => import("./components/Upload"));
const App = () => (React.createElement(HashRouter, null,
    React.createElement(Header, null),
    React.createElement(Auth, null,
        React.createElement(GetPermissions, null,
            React.createElement(Subnav, null),
            React.createElement(Suspense, { fallback: React.createElement(Loading, null) },
                React.createElement(Switch, null,
                    React.createElement(Route, { exact: true, path: "/add", component: Add }),
                    React.createElement(Route, { exact: true, path: "/help", component: Help }),
                    React.createElement(Route, { exact: true, path: "/help_old", component: HelpOld }),
                    React.createElement(Route, { exact: true, path: "/upload", component: Upload }),
                    React.createElement(Route, { exact: true, path: "/:id", component: Acronym }),
                    React.createElement(Route, { exact: true, path: "/:id/:action", component: Acronym }),
                    React.createElement(Route, { component: Home })))))));
export default App;
